"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = require("./Utils");
exports.DATE_REGEXP_WITHOUT_DASH = /^[0-9]{8}$/;
exports.DATE_REGEXP_WITH_DASH = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
exports.DATE_REGEXP_WITH_SLASH = /^[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/;
exports.PREFERRED_DATE_FORMAT = 'YYYY-MM-DD';
function validLimit(limit) {
    if (typeof limit !== 'string' || Utils_1.isEmpty(limit)) {
        throw new Error("limit must be a non-empty string");
    }
    var limitAsString = limit;
    if (!exports.DATE_REGEXP_WITH_DASH.test(limitAsString)) {
        throw new Error("limit has invalid format");
    }
    return limitAsString;
}
exports.validLimit = validLimit;
//# sourceMappingURL=DateUtils.js.map